
<!-- Navbar -->
<app-navbar-style-two></app-navbar-style-two>

<!-- Start Blog Area -->
<section class="blog-area">

    <div class="container">

        <!-- Section Title -->
        <div class="section-title" *ngFor="let Content of sectionTitle">
            <h2>{{Content.title}}</h2>
        </div>

        <!-- Blog Posts -->
        <div class="row justify-content-center g-4">

            <div class="col-12 col-sm-6 col-lg-4"
                 *ngFor="let Content of singleBlogPost">

                <div class="single-blog-post">

                    <!-- Blog Image -->
                    <div class="post-image">

                        <img [src]="Content.imageUrl"
                             [alt]="Content.postTitle"
                             class="responsive-img">

                    </div>

                    <!-- Blog Content -->
                    <div class="post-content">

                        <h3>{{Content.postTitle}}</h3>

                        <p>{{Content.postDesciption}}</p>

                        <a [routerLink]="['/post', Content.keywords]"
                           class="link-btn">

                            Read more
                            <i class="bx bx-right-arrow-alt"></i>

                        </a>

                    </div>

                </div>

            </div>

        </div>

    </div>

</section>
<!-- End Blog Area -->
